import { render, staticRenderFns } from "./ScheduleProgramModuleDay.vue?vue&type=template&id=4365c760&scoped=true"
import script from "./ScheduleProgramModuleDay.vue?vue&type=script&lang=js"
export * from "./ScheduleProgramModuleDay.vue?vue&type=script&lang=js"
import style0 from "./ScheduleProgramModuleDay.vue?vue&type=style&index=0&id=4365c760&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4365c760",
  null
  
)

export default component.exports